// extracted by mini-css-extract-plugin
export default {"header":"styles__header___x7grp","submitter":"styles__submitter___CJlc4","name":"styles__name___3TZEN styles__submitter___CJlc4","status":"styles__status___-XaE0"};